import { SVGProps } from 'react';

function ArrowRightPassword(
  props: JSX.IntrinsicAttributes & SVGProps<SVGSVGElement>
) {
  return (
    <svg
      width={18}
      height={16}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M1.5 8h15M9.5 15l7-7-7-7"
        stroke="#7E849A"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

ArrowRightPassword.defaultProps = {
  role: 'graphics-document',
};

export default ArrowRightPassword;
